import { Modal } from "components";

import { LocationGenerics } from "router/location";
import UpdateSlipKEKWizardContainer from "components/forms/slip-wizard/update-kek";
import { useKEKOffer } from "hooks/data/use-offers";
import { useSearch } from "react-location";

export { validationSchemaKEKUpdate as validationSchema } from "components/forms/slip-wizard/validation";

export default function UpdateKEKOfferContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const { loading: fetching, offer } = useKEKOffer({
        offer_id: searchParams.id || "",
    });

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            size="4xl"
            loading={fetching}
            hideActions
            title="Update Offer"
            description="Provide the details to update offer">
            <UpdateSlipKEKWizardContainer
                setClose={setOpen}
                refetch={refetch}
                offer={offer}
                offerId={searchParams.id}
            />
        </Modal>
    );
}
